import copilotSettingsStore from '../store/store';

export function getTenantDefaultAddin(mailboxInfo: any) {
    const store = copilotSettingsStore(mailboxInfo);
    return store.extensibility.settingsFromService?.metaOSApps?.tenantDefault;
}
